import { render, staticRenderFns } from "./UpdateOrganization.vue?vue&type=template&id=79616d5e&scoped=true"
import script from "./UpdateOrganization.vue?vue&type=script&lang=js"
export * from "./UpdateOrganization.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrganization.vue?vue&type=style&index=0&id=79616d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79616d5e",
  null
  
)

export default component.exports